import axios from 'axios';
import { Input } from 'components/SignInput';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { ContinueButton } from '../ContinueButton';
import { PortCollections } from './PortCollections';

interface PortDetailFormValues {
  volume: number;
  portCollections: string[];
}

interface Props {
  submit: (values: PortDetailFormValues) => Promise<void>;
}

export const Shippers: React.FC<Props> = (props) => {
  const { register, watch, setValue, formState, handleSubmit } = useForm<PortDetailFormValues>({
    defaultValues: { portCollections: [] },
  });

  const [error, setError] = React.useState('');

  const { submit } = props;
  const onSubmit = handleSubmit(async (values: PortDetailFormValues) => {
    try {
      await submit(values);
    } catch (err) {
      if (axios.isAxiosError(err)) {
        setError(err.response?.data.message || err.message);
      } else {
        setError('A problem ocurred while creating the company.');
      }
      // eslint-disable-next-line
      console.error(err);
    }
  });

  register('portCollections', { required: true });
  const portCollections = watch('portCollections');

  return (
    <form onSubmit={onSubmit} className="space-y-8 flex flex-col items-center">
      <div className="w-full max-w-[520px]">
        <Input
          label="Your yearly container volume"
          type="number"
          placeholder="How many containers do you move every year?"
          inputProps={register('volume', { required: true })}
        />
      </div>
      <PortCollections
        value={portCollections}
        onChange={(value) => {
          setValue('portCollections', value, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          });
        }}
      />
      <div className="w-full max-w-[520px] !mt-16">
        <ContinueButton
          disabled={!formState.isValid}
          loading={formState.isSubmitting}
          error={error}
        />
      </div>
    </form>
  );
};
Shippers.displayName = 'CompanyDetails.Shippers';
